export const defaultMapConfig = {
	initialCenter: [-74.5, 40] as [number, number],
	initialZoom: 9,
	style: "mapbox://styles/mapbox/streets-v11",
};

export const mapStyles = {
	streets: "mapbox://styles/mapbox/streets-v11",
	satellite: "mapbox://styles/mapbox/satellite-v9",
	light: "mapbox://styles/mapbox/light-v10",
	dark: "mapbox://styles/mapbox/dark-v10",
	outdoors: "mapbox://styles/mapbox/outdoors-v11",
};

export const mapControls = {
	navigation: {
		position: "bottom-right" as const,
	},
	geolocate: {
		position: "bottom-right" as const,
		options: {
			positionOptions: {
				enableHighAccuracy: true,
			},
			trackUserLocation: true,
		},
	},
};
